import { g as L } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { g as T, c as B } from "./generateUtilityClass-DMFG5-Cu.mjs";
import * as u from "react";
import { j as y } from "./jsx-runtime-3tyXYecC.mjs";
import { s as M, u as R, c as $ } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { t as I, T as l } from "./Typography-DfkimCSn.mjs";
const j = /* @__PURE__ */ u.createContext({});
function F(t) {
  return T("MuiListItemButton", t);
}
const V = L("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function w(t) {
  return T("MuiListItemText", t);
}
const m = L("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), U = (t) => {
  const {
    classes: e,
    inset: s,
    primary: a,
    secondary: c,
    dense: p
  } = t;
  return $({
    root: ["root", s && "inset", p && "dense", a && c && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, w, e);
}, N = M("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (t, e) => {
    const {
      ownerState: s
    } = t;
    return [{
      [`& .${m.primary}`]: e.primary
    }, {
      [`& .${m.secondary}`]: e.secondary
    }, e.root, s.inset && e.inset, s.primary && s.secondary && e.multiline, s.dense && e.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${I.root}:where(& .${m.primary})`]: {
    display: "block"
  },
  [`.${I.root}:where(& .${m.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.primary && t.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), W = /* @__PURE__ */ u.forwardRef(function(e, s) {
  const a = R({
    props: e,
    name: "MuiListItemText"
  }), {
    children: c,
    className: p,
    disableTypography: i = !1,
    inset: C = !1,
    primary: x,
    primaryTypographyProps: n,
    secondary: h,
    secondaryTypographyProps: b,
    ...v
  } = a, {
    dense: f
  } = u.useContext(j);
  let r = x ?? c, o = h;
  const g = {
    ...a,
    disableTypography: i,
    inset: C,
    primary: !!r,
    secondary: !!o,
    dense: f
  }, d = U(g);
  return r != null && r.type !== l && !i && (r = /* @__PURE__ */ y.jsx(l, {
    variant: f ? "body2" : "body1",
    className: d.primary,
    component: n != null && n.variant ? void 0 : "span",
    ...n,
    children: r
  })), o != null && o.type !== l && !i && (o = /* @__PURE__ */ y.jsx(l, {
    variant: "body2",
    className: d.secondary,
    color: "textSecondary",
    ...b,
    children: o
  })), /* @__PURE__ */ y.jsxs(N, {
    className: B(d.root, p),
    ownerState: g,
    ref: s,
    ...v,
    children: [r, o]
  });
});
export {
  j as L,
  W as a,
  F as g,
  V as l
};
//# sourceMappingURL=ListItemText-C34sqqNp.mjs.map
